export enum StakeholderType {
  NonRegulatedAO = "nonregulatedAO",
  Apprentice = "Apprentice",
  Ifate = "IfATE",
  Trailblazer = "Trailblazer",
  RegulatedAO = "RegulatedAO",
  Other = "Other",
  Employer = "Employer",
}